// Public app version from REACT_APP_VERSION (mapped in vite.config.mjs; set in
// .env.production for releases). Empty when unset so callers can hide it.
export const APP_VERSION = String(process.env.REACT_APP_VERSION || '').trim();
